var map = {
	"./platformApp": [
		"481a",
		"platformApp"
	],
	"./platformApp.js": [
		"481a",
		"platformApp"
	],
	"./platformCommon": [
		"21cf",
		"platformCommon"
	],
	"./platformCommon.js": [
		"21cf",
		"platformCommon"
	],
	"./platformDingtalk": [
		"c3e7",
		"platformDingtalk"
	],
	"./platformDingtalk.js": [
		"c3e7",
		"platformDingtalk"
	],
	"./platformToon": [
		"edee",
		"platformToon"
	],
	"./platformToon.js": [
		"edee",
		"platformToon"
	],
	"./platformWechat": [
		"d417",
		"platformWechat"
	],
	"./platformWechat.js": [
		"d417",
		"platformWechat"
	],
	"./platformWelink": [
		"b8df",
		"platformWelink"
	],
	"./platformWelink.js": [
		"b8df",
		"platformWelink"
	],
	"./platformZhuoyun": [
		"35de",
		"platformZhuoyun"
	],
	"./platformZhuoyun.js": [
		"35de",
		"platformZhuoyun"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a84d";
module.exports = webpackAsyncContext;